const map = {
	"./en/about.json": 8931,
	"./en/blocks.json": 2844,
	"./en/booking.json": 5477,
	"./en/common.json": 6251,
	"./en/contact.json": 4814,
	"./en/faq.json": 2638,
	"./en/guide.json": 5798,
	"./en/home.json": 6953,
	"./en/learn.json": 9284,
	"./en/links.json": 3419,
	"./en/reviews.json": 1915,
	"./en/services.json": 5498,
	"./en/testimonials.json": 5922,
	"./en/tiktok.json": 1864,
	"./en/widgets.json": 2247,
	"./ru/about.json": 5881,
	"./ru/blocks.json": 3242,
	"./ru/booking.json": 3003,
	"./ru/common.json": 13,
	"./ru/contact.json": 3124,
	"./ru/faq.json": 4320,
	"./ru/guide.json": 9624,
	"./ru/home.json": 6831,
	"./ru/learn.json": 2618,
	"./ru/links.json": 4829,
	"./ru/reviews.json": 7169,
	"./ru/services.json": 7248,
	"./ru/testimonials.json": 7508,
	"./ru/tiktok.json": 2334,
	"./ru/widgets.json": 1377,
	"./uk/about.json": 2956,
	"./uk/blocks.json": 4261,
	"./uk/booking.json": 7458,
	"./uk/common.json": 5490,
	"./uk/contact.json": 7613,
	"./uk/faq.json": 593,
	"./uk/guide.json": 9334,
	"./uk/home.json": 5500,
	"./uk/learn.json": 3667,
	"./uk/links.json": 1024,
	"./uk/reviews.json": 100,
	"./uk/services.json": 387,
	"./uk/testimonials.json": 563,
	"./uk/tiktok.json": 6365,
	"./uk/widgets.json": 9292
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2090;